import { useEffect, useRef, useState } from "react"
import { fetchFilteredprojects, getProjectById, ProjectType } from "../../io/projects_api"
import { useLocation, useParams } from "react-router-dom"
import FadeInWhenStart from "../../animations/FadeInWhenStart"
import { Link } from "react-router-dom"
import FadeInWhenInView from "../../animations/FadeInWhenInView"
import ProjectFooter from "./components/ProjectFooter"
import Project from "../mainpage/components/Project"
import Video from "../../common/Video"

const ProjectPage = () => {
      const location = useLocation();
      const params = useParams()
      const scrollRef = useRef<HTMLDivElement | null>(null)
      

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;

        const handleWheel = (e: WheelEvent) => {
            // Only if horizontally scrollable
            if (el.scrollWidth <= el.clientWidth) return;
            if((el.scrollLeft + e.deltaY) > 0 && (el.scrollLeft + e.deltaY) < (el.scrollWidth - el.clientWidth)){
                e.preventDefault();
                el.scrollLeft += e.deltaY;
            }
        };

        el.addEventListener("wheel", handleWheel, { passive: false });

        return () => {
            el.removeEventListener("wheel", handleWheel);
        };
    }, [scrollRef]);
        
      useEffect(() => {
            const pro = getProjectById(parseInt(params.id || "0"))
            setProject(pro)
            scrollToTop()
        }, [location, params.id]);


    const [project, setProject] = useState<ProjectType | null>(null)

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0 , behavior: "smooth"});
    };

    useEffect(() => {
        scrollToTop()
        const pro:any = getProjectById(parseInt(params.id || "0"))
        setProject(pro)
    }, [params.id])

    const determineGridLayout = (e: any) => {
        const element: HTMLImageElement = e.target
        const proportions = element.height/element.width
        if( proportions < 0.8){
            element.style.gridColumn  = "span 2"
        }else{
            element.style.gridColumn  = "span 1"
        }
    }

    const [projects, setProjects] = useState<Array<ProjectType>>([])

    useEffect(() => {
        setProjects(fetchFilteredprojects(''))
    }, [])

    // const determineGridLayoutVideo = (e: any) => {
    //     const element: HTMLVideoElement = e.target
    //     const proportions = element.videoHeight/element.videoWidth
    //     if( proportions < 0.8){
    //         element.style.gridColumn  = "span 2"
    //     }else{
    //         element.style.gridColumn  = "span 1"
    //     }
    // }


    return(
        <>
            <div className="w-screen flex flex-col gap-12 bg-black">
                <div className="w-full text-white flex flex-col gap-4 md:gap-8 xl:gap-12 justify-between py-8 px-0 md:px-10 z-10" id="home">
                    <div className="w-full flex justify-between">
                        <FadeInWhenStart classname="w-full" delay={0.1}>
                            <Link to={'/'}>
                                <div className="text-2xl font-semibold hover:cursor-cur_hover active:cursor-fancyactive_b">  {/*ToDo: replace this with image*/}
                                    <div className="w-full flex md:justify-start justify-center py-8 md:py-4">
                                    <img src="/logo/logo.svg" alt="not found" className="w-36 md:w-48 flex"/>
                                    {/* <img src="/archive42_logo_white.svg" alt="not found" className="w-full flex dark:hidden "/> */}
                                    </div>
                                </div>
                            </Link>
                        </FadeInWhenStart>
                    </div>
                    <div className="w-full px-4 md:px-12 lg:px-20 xl:px-28 md:pt-8 flex flex-col gap-1 md:gap-6 xl:gap-11">
                        <FadeInWhenStart delay={0.1}><div className="text-2xl md:text-3xl lg:text-5xl xl:text-7xl font-semibold">{project?.title}</div></FadeInWhenStart>
                        <FadeInWhenStart delay={0.1}><div className="xl:text-4xl text-gray w-full md:w-2/3">{project?.subtitle}</div></FadeInWhenStart>
                        <FadeInWhenStart delay={0.2}><div className="w-full object-cover rounded-2xl">
                            <img src={project?.title_img_url} alt="NO IMG AVAILABLE" className="rounded-2xl my-4 border-solid border-gray border-[1px]"/>
                        </div></FadeInWhenStart>
                        <div className="flex flex-col gap-8 md:gap-0 md:grid md:grid-cols-2 w-full text-md md:text-lg lg:text-xl xl:text-2xl">
                            <div className="flex flex-col uppercase gap-6 w-4/5">
                                <FadeInWhenInView margin={0.2} delay={0}>
                                    <div>
                                        <div className="font-semibold">CLIENT</div>
                                        <div className="text-gray">{project?.client}</div>
                                    </div>
                                </FadeInWhenInView>
                                <FadeInWhenInView margin={0.2} delay={0.2}>
                                <div>
                                    <div className="font-semibold">YEAR</div>
                                    <div className="text-gray">{project?.year}</div>
                                </div>
                                </FadeInWhenInView>
                                <FadeInWhenInView margin={0.2} delay={0.3}>
                                    <div>
                                        <div className="font-semibold">PROJECT TYPE</div>
                                        <div className="text-gray">{project?.project_type}</div>
                                    </div>
                                </FadeInWhenInView>
                                <FadeInWhenInView margin={0.2} delay={0.4}>
                                    <div>
                                        <div className="font-semibold">FIELD</div>
                                        <div className="text-gray">{project?.field}</div>
                                    </div>
                                </FadeInWhenInView>
                            </div>
                                <div lang="en" className="pb-4 md:py-0 md:col-start-2 text-gray text-justify hyphens-auto [text-align-last:left] leading-relaxed uppercase whitespace-pre-line text-sm md:text-lg lg:text-xl xl:text-2xl">
                                    {project?.info}
                                </div>
                        </div>
                        <div className="w-full grid grid-cols-2 gap-2 md:gap-4">
                            {project?.image_urls.map((src, index) => (
                                src.startsWith("http") ? (
                                    <FadeInWhenInView classname="col-span-2" delay={0} margin={0.2} key={index}>
                                        <Video src={src} key={index}/>
                                    </FadeInWhenInView>
                                            
                                ) : (
                                    <img
                                        key={index}
                                        className="rounded-xl w-full border-solidborder-gray border-[1px]"
                                        src={src}
                                        alt="Not found"
                                        onLoad={(e) => determineGridLayout(e)}
                                    />
                                )
                            ))}
                        </div>
                        <div className="mt-4 md:mt-12 flex flex-col gap-4 md:gap-8 xl:gap-12">
                            <div className="text-2xl md:text-3xl lg:text-5xl xl:text-7xl font-semibold">MORE ARCHIVE42</div>
                                <div
                                    ref={scrollRef}
                                    className="flex gap-4 lg:gap-8 xl:gap-12 w-full overflow-x-auto overflow-y-hidden py-0 lg:py-4" 
                                    style={{
                                        msScrollbarArrowColor: "#000000",
                                        scrollbarWidth: "thin",
                                        scrollbarColor: "#cecece #000000",
                                        msScrollbarFaceColor: "#0000FF"
                                    }}>
                                    {
                                        projects.map((project, index) => {
                                            return <Project key={index} project={project} />
                                        })
                                    }
                                </div>
                        </div>
                    </div>
                </div>

                <ProjectFooter />
            </div>
        </>

    )
}

export default ProjectPage